import React, { type Dispatch, type SetStateAction, useCallback, useRef } from 'react';
import dynamic from 'next/dynamic';
import { type DropdownOptionShape } from '@cvent/carina/components/Dropdown';

const Dropdown = dynamic(() => import('@/components/shared/Dropdown').then(mod => mod.default), {
  ssr: false
});

interface Props {
  sortOptions: DropdownOptionShape[];
  sortAriaLabel: string;
  sort: string;
  setSort: Dispatch<SetStateAction<string>>;
}

export default function AllFiltersSortBy({ sortAriaLabel, sortOptions, sort, setSort }: Props): JSX.Element {
  const triggerRef = useRef<HTMLDivElement | null>(null);

  const handleSortTypeChange = useCallback(
    (value: string) => {
      setSort(value);
    },
    [setSort]
  );

  return (
    <div className="border-b border-neutral-20 lg:hidden xl:hidden 2xl:hidden" data-cvent-id="all-filters-sort-by">
      <div className="mb-3 mr-2 flex text-b-xl/loose font-medium" ref={triggerRef}>
        {sortAriaLabel}
      </div>
      <div className="pb-8">
        <Dropdown
          testID="all-filters-sort-by-dropdown"
          accessibilityLabel={sortAriaLabel}
          options={sortOptions}
          selected={sort}
          onUpdate={value => handleSortTypeChange(value)}
          portal={triggerRef}
          zIndex={30}
        />
      </div>
    </div>
  );
}
